import styled from 'styled-components';

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
`;

export const Title = styled.h3`
  font-size: 1.25em;
  text-align: left;
  margin: 0.4em;
`;
